import { Section, SectionParagraph, SectionTitle } from '@/components/shared/Content';
import { Flex } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis-atomic';
import type { StaticImageData } from 'next/image';
import type React from 'react';
import styled from 'styled-components';

const StyledSectionTitle = styled(SectionTitle)`
  font-size: 2.8rem;
  ${MEDIA_QUERIES.tabletAndDesktop`
    font-size: 4rem;
  `}
`;

const StyledSectionParagraph = styled(SectionParagraph)`
  font-size: 1.8rem;
  ${MEDIA_QUERIES.tabletAndDesktop`
    font-size: 1.8rem;
    max-width: 720px;
  `}
`;

interface PartnerLogo {
  src: StaticImageData;
  alt: string;
}

export interface GoodForWorldSectionProps {
  title: string;
  subtitle: string;
  logos: PartnerLogo[];
}

const LogosContainer = styled(Flex)`
  gap: 40px;
  margin-top: 40px;
  justify-content: center;
  align-items: center;

  ${MEDIA_QUERIES.tabletAndDesktop`
    gap: 60px;
    margin-top: 60px;
  `}
`;

const LogoImage = styled.div<{ $src: StaticImageData }>`
  height: 38px;
  background-image: url(${({ $src }) => $src.src});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: auto;
  aspect-ratio: ${({ $src }) => $src.width / $src.height};

  ${MEDIA_QUERIES.tabletAndDesktop`
    height: 68px;
  `}
`;

export const GoodForWorldSection: React.FC<GoodForWorldSectionProps> = ({ title, subtitle, logos }) => {
  return (
    <Section py={[60, 100]} px="20px">
      <Flex flexDirection="column" gap="20px" alignItems="center">
        <StyledSectionTitle>{title}</StyledSectionTitle>
        <StyledSectionParagraph>{subtitle}</StyledSectionParagraph>
      </Flex>
      <LogosContainer>
        {logos.map((logo, index) => (
          <LogoImage key={index} $src={logo.src} aria-label={logo.alt} role="img" />
        ))}
      </LogosContainer>
    </Section>
  );
};
